
<script>
    import {
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    CardFooter,
    CardSubtitle,
    CardText
} from 'sveltestrap';

export let name;

</script>
<Card body color="light" class="p-0 mx-auto">
    <CardHeader>
      <CardTitle color="info">{name}</CardTitle>
    </CardHeader>
    <CardBody>
        <CardText>
           <p>
            All'interno del progetto  <a href="https://hpc4ai.unito.it" class="text-secondary">HPC4AI</a> sono state installate, in diverse aree del dipartimento di informatica, delle centraline per il monitoraggio ambientale.
           </p> 
           <p>
               Le centraline, risultato di aGrisù (academic spin off dell'Università di Torino), sono posizionate attualmente in due locali al primo piano, in un ufficio al terzo piano e due sono dedicate al controllo delle emissioni del nuovo CED dipartimentale e sono posizionate una all'interno e una all'esterno del CED.
           </p>
           <p> 
               L'intenzione è di fornire uno strumento utile a controllare lo stato dei locali che giornalmente frequentiamo e per quanto riguarda il CED, fornire indicazioni sull'impatto ambientale della nuova infrastruttura, pensata per essere altamente efficiente in termini di consumi e contestualmente rispettosa dell'ambiente e delle persone che abitano il comprensorio.
           </p>
        </CardText>
    </CardBody>
</Card>